// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"383":"c9772f30","437":"722c540e","786":"39bd774d"}[chunkId] + ".chunk.js";
};